import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { ModalidadInterface } from '../models/modalidad.model';

@Injectable({
  providedIn: 'root'
})

export class ModalidadService extends ApiService<ModalidadInterface>{
  url="modalidades"
}
